import {} from "../port/index.js";
import {} from "./Net.js";
import { findNodeEntry } from "./findNodeEntry.js";
export function findPortEntry(net, port) {
    const nodeEntry = findNodeEntry(net, port.node);
    if (nodeEntry === undefined) {
        return undefined;
    }
    return nodeEntry.ports[port.name];
}
//# sourceMappingURL=findPortEntry.js.map